import React, { useEffect, useState } from 'react';
import { Box, Stack, TextField, FormControlLabel, Switch, Typography } from '@mui/material';
import { fetchPersonalQuestions, QuestionDto } from '../../api/questionsApi';
import { QuestionFilter } from '../../models/worker';

interface Props {
  language?: string;
  value: QuestionFilter[];
  onChange: (filters: QuestionFilter[]) => void;
}

const DynamicPersonalFilters: React.FC<Props> = ({ language, onChange }) => {
  const [, setQuestions] = useState<QuestionDto[]>([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [zzp, setZzp] = useState<'any' | 'yes' | 'no'>('any');
  const [dobFrom, setDobFrom] = useState('');
  const [dobTo, setDobTo] = useState('');

  useEffect(() => {
    fetchPersonalQuestions(language).then(setQuestions).catch(() => setQuestions([]));
  }, [language]);

  useEffect(() => {
    const filters: QuestionFilter[] = [];
    if (firstName) filters.push({ key: 'firstName', answerType: 'TEXT', operator: 'contains', value: firstName });
    if (lastName) filters.push({ key: 'lastName', answerType: 'TEXT', operator: 'contains', value: lastName });
    if (email) filters.push({ key: 'emailAddress', answerType: 'TEXT', operator: 'contains', value: email });
    if (phone) filters.push({ key: 'phoneNumber', answerType: 'TEXT', operator: 'contains', value: phone });
    if (zzp !== 'any') filters.push({ key: 'zzp', answerType: 'BOOLEAN', operator: 'equals', value: zzp === 'yes' });
    if (dobFrom || dobTo) filters.push({ key: 'dateOfBirth', answerType: 'DATE', operator: 'between', value: { from: dobFrom || undefined, to: dobTo || undefined } });
    onChange(filters);
  }, [firstName, lastName, email, phone, zzp, dobFrom, dobTo]);

  // Render minimal, typed personal filters
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Personal</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 1 }}>
        <TextField size="small" label="First name contains" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        <TextField size="small" label="Last name contains" value={lastName} onChange={(e) => setLastName(e.target.value)} />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 1 }}>
        <TextField size="small" label="Email contains" value={email} onChange={(e) => setEmail(e.target.value)} />
        <TextField size="small" label="Phone contains" value={phone} onChange={(e) => setPhone(e.target.value)} />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 1 }}>
        <FormControlLabel
          control={<Switch checked={zzp === 'yes'} onChange={(_, ch) => setZzp(ch ? 'yes' : (zzp === 'no' ? 'any' : 'no'))} />}
          label={`ZZP: ${zzp === 'any' ? 'Any' : zzp === 'yes' ? 'Yes' : 'No'}`}
        />
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <TextField size="small" type="date" label="DOB from" InputLabelProps={{ shrink: true }} value={dobFrom} onChange={(e) => setDobFrom(e.target.value)} />
        <TextField size="small" type="date" label="DOB to" InputLabelProps={{ shrink: true }} value={dobTo} onChange={(e) => setDobTo(e.target.value)} />
      </Stack>
    </Box>
  );
};

export default DynamicPersonalFilters;

